import { render } from "./mypageBasic.vue?vue&type=template&id=4c297312&scoped=true"
import script from "./mypageBasic.vue?vue&type=script&lang=js"
export * from "./mypageBasic.vue?vue&type=script&lang=js"

import "./mypageBasic.vue?vue&type=style&index=0&id=4c297312&scoped=true&lang=css"
import "@/assets/css/style_parts.css?vue&type=style&index=1&id=4c297312&lang=css&scoped=true"
import "@/assets/css/style_mypage.css?vue&type=style&index=2&id=4c297312&lang=css&scoped=true"
import "./mypageBasic.vue?vue&type=style&index=3&id=4c297312&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c297312"]])

export default __exports__